'use client';
import React from 'react';
import Image from 'next/image';

export default function Header() {
  return (
    <header className="w-full grain-texture" style={{ background: 'linear-gradient(180deg, #0a0a0b 0%, #111113 60%, #1C1C1E 100%)' }}>
      {/* Logo + tagline bar */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <Image
            src="/assets/images/ChatGPT_Image_May_22_2026_01_33_45_AM-1779432418643.png"
            alt="Lotus Line Detailing Logo"
            width={64}
            height={64}
            className="rounded-full object-cover"
            style={{ border: '1px solid rgba(212,212,216,0.15)' }}
          />
          <div>
            <span className="text-xl md:text-2xl font-bold tracking-tight" style={{ color: '#F5F5F7', letterSpacing: '-0.01em' }}>
              Lotus Line Detailing
            </span>
            <p className="mono text-[9px] tracking-widest uppercase mt-0.5" style={{ color: 'rgba(168,169,173,0.5)' }}>
              Mobile · Premium · Professional
            </p>
          </div>
        </div>
        <div className="flex items-center gap-6">
          {['Services', 'Pricing', 'FAQ', 'Contact']?.map((link) => (
            <a
              key={link}
              href={`#${link?.toLowerCase()}`}
              className="mono text-[10px] font-medium tracking-widest uppercase transition-colors duration-200 hidden md:block"
              style={{ color: 'rgba(168,169,173,0.6)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#F5F5F7')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(168,169,173,0.6)')}
            >
              {link}
            </a>
          ))}
          <a
            href="tel:+1-555-000-0000"
            className="btn-sapphire px-5 py-2.5 rounded-full mono text-[10px] font-semibold tracking-widest uppercase text-white"
          >
            Book Now
          </a>
        </div>
      </div>
      {/* Bottom chrome line */}
      <div className="chrome-divider" />
    </header>
  );
}